import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import { ErrorBoundary } from '../components/error/ErrorBoundary';
import { ConfirmProvider, ToastProvider } from '../components/ui';

interface ProvidersProps {
  children: ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ToastProvider>
          <ConfirmProvider>{children}</ConfirmProvider>
        </ToastProvider>
      </Provider>
    </ErrorBoundary>
  );
};
